import axios from 'axios';
import { takeLatest, put } from 'redux-saga/effects';
import actionCreator from 'utils/actionCreator';
import { bookingsActions } from './bookings';

/**
 * Action Types
 */
export const bookingsAppointmentsActionTypes = {
    REQUEST: '@app/bookings/appointments/REQUEST',
    FAILURE: '@app/bookings/appointments/FAILURE',
    SUCCESS: '@app/bookings/appointments/SUCCESS',
}

/**
 * Redux Actions
 */
export const bookingsAppointmentsActions = {
    request: actionCreator(bookingsAppointmentsActionTypes.REQUEST),
    success: actionCreator(bookingsAppointmentsActionTypes.SUCCESS),
    failure: actionCreator(bookingsAppointmentsActionTypes.FAILURE)
};

/**
 * Saga Functions
 */
export const sagas = {
    *request({ payload, resolve, reject }) {
        try {
            const res = yield axios.get('/bookings/available-appointments', {
                params: {
                    date: payload.date,
                    barberId: payload.barberId
                }
            });

            yield put(bookingsActions.appointments({ availableAppointments: res.data.availableAppointments }));
            yield put(bookingsAppointmentsActions.success());

            resolve(res.data);
        } catch (err) {
            yield put(bookingsAppointmentsActions.failure(err.response.data.errors));
            reject(err);
        }
    }
}

/**
 * Saga Watchers
 */
export const bookingsAppointmentsWatchers = function* () {
    yield takeLatest(bookingsAppointmentsActionTypes.REQUEST, sagas.request)
}
